<template>
    <div class="page-content" id="patrol-list">
        <Titlebar :incrustation="'fa-history'">
            <h1>{{ $t('nav.patrols2') }}</h1>
        </Titlebar>
        <!--<div class="full-height" style="position: relative;">-->
            <LoadingMini ref="loading"></LoadingMini>
            <UiCard>
                <SuperTable
                    ref="tablePatrols" 
                    :tableColumns="tableColumns" 
                    :tableData="tableData"
                    @sort="handleSort" 
                    @filter="handleFilter" 
                    @delete="handleDelete"
                    @copy="handleCopy"
                />
            </UiCard>
            <Toolbar>
                <div class="row">
                    <div class="col">
                        <Btn
                            class="primary"
                            v-can="'beepiz-add-patrols'" 
                            to="/patrols/new"
                        >
                            <i class="fa fa-plus"></i><span>{{ $t('patrol.btns.add') }}</span>
                        </Btn>
                    </div>
                    <div class="col center">
                        <Pagination ref="pagination" @change="handlePagination"></Pagination>
                    </div>
                    <div class="col">
                    </div>
                </div>
            </Toolbar>
        <!--</div>-->
    </div>
</template>

<script>

    import axios from 'axios';
    import API from '@/services/API.js';
    import Auth from '@/services/auth.js'
    import Utils from '@/services/utils.js'
    import Titlebar from "@/components/ui/Titlebar";
    import Toolbar from "@/components/ui/Toolbar";
    import Btn from "@/components/ui/Button";
    import UiCard from "@/components/ui/Card";
    import Pagination from "@/components/ui/Pagination";
    import SuperTable from "@/components/ui/Table";
    import Globals from '@/services/globals.js';

    import LoadingMini from '@/components/ui/LoadingMini';

    import UserRenderer from "@/components/identifications/TableRowUserRenderer";
    import {useDvFlagAccess} from "../../services/featureFlag";

    export default {
        name: 'PatrolsList',
        components: {
            Titlebar,
            Toolbar,
            Btn,
            UiCard,
            Pagination,
            SuperTable,
            LoadingMini
        },
        data: () => ({
            count: 0,
            config: {
                perpage: Globals.perPage,
                fields: [],
                page: 1,
                filter: {
                    like: [],
                    equals: []
                },
                sort: []
            },
            tableColumns: {
                global: {
                    sortable: false,
                    noItemsMsg: window.V.$i18n.t('patrol.emptyTable')
                },
                columns: [
                    {
                        key: 'name',
                        label: Utils.t('patrol.name'),
                        showPopup: false,
                        activeFilter: '',
                        activeSort: '+',
                        sortable: true,
                        filter: {
                            type: 'text'
                        },
                        width: '55%',
                        className: 'bold',
                        linkTo: useDvFlagAccess("beepiz-patrols-can:update") ? '/patrols/:id' : null
                    },
                    {
                        key: 'checkpointCount',
                        label: Utils.t('patrol.checkpointCount'),
                        showPopup: false,
                        activeFilter: '',
                        activeSort: false,
                        sortable: true,
                        filter: false,
                        width: '15%',
                        className:'right-align'
                    },
                    {
                        key: 'manageTravelTime',
                        label: Utils.t('patrol.manageTravelTime'),
                        showPopup: false,
                        activeFilter: '',
                        activeSort: false,
                        sortable: true,
                        filter: false,
                        width: '15%',
                        className:'center-align',
                        showTooltip: true,
                        tooltipTitle:Utils.t('patrol.tooltip.title'),
                        tooltipContent:Utils.t('patrol.tooltip.content'),
                        renderer: function(item){
                            if(item.manageTravelTime == 1){
                                return '<i class="fa fa-2x fa-clock-o"></i>'
                            }
                            return ''
                        }
                    }
                ],
                rowActions: {
                    width: '15%',
                    actions: [
                        {
                            label: Utils.t('global.copy'),
                            class: 'fa fa-copy',
                            event: 'copy'
                        },
                        {
                            label: Utils.t('global.delete'),
                            class: 'fa fa-trash',
                            event: 'delete'
                        }
                    ]
                }
            },
            tableData: []
        }),

        created(){

        },

        methods: {
            handlePagination: function (page) {
                this.config.page = page;
                this.loadData();
            },
            handleSort: function () {
                this.config.sort = [];
                for (var colKey in this.tableColumns.columns) {
                    var col = this.tableColumns.columns[colKey];
                    if (col.activeSort) {
                        this.config.sort.push(col.activeSort + col.key);
                    }
                }
                this.loadData();
            },
            handleFilter: function () {
                this.config.page = 1;
                this.config.filter.like = [];
                this.config.filter.equals = [];
                for (var colKey in this.tableColumns.columns) {
                    var col = this.tableColumns.columns[colKey];
                    if (col.activeFilter !== '') {
                        if (col.filter && col.filter.type == 'text') {
                            this.config.filter.like.push(col.key + ':' + col.activeFilter);
                        }
                        if (col.filter && col.filter.type == 'list') {
                            this.config.filter.equals.push(col.key + ':' + col.activeFilter);
                        }
                    }
                }
                this.loadData();
            },
            handleCopy: function (item) {
                window.V._router.push('/patrols/' + item.id + '/copy');
            },
            handleDelete: function (item) {
                window.Vfc.$refs.confirm.show({
                    title: Utils.t('global.deleteModalTitle'),
                    content: Utils.t('global.deleteModalContent'),
                    callbackYes: () => {
                        axios.delete(API.route(API.endpoints.patrols.delete, {patrolId: item.id}))
                            .then(response => {
                                if(this.tableData.length == 1 && this.config.page > 1){
                                    this.config.page--;
                                }
                                this.loadData();
                            })
                            .catch(e => {
                                this.$refs.loading.hide();
                            });
                    }
                });
            },
            loadData: function () {
                this.$refs.loading.show();
                axios.get(API.endpoints.patrols.index + API.constructQueryParams(this.config))
                    .then(response => {
                        this.tableData = response.data.data;
                        this.count = response.data.meta.pagination.total;
                        this.$refs.pagination.update(response.data.meta.pagination);
                        this.$refs.loading.hide();
                        window.Vfc.$refs.loading.hide();
                    })
                    .catch(e => {
                        this.$refs.loading.hide();
                        window.Vfc.$refs.loading.hide();
                    })
            }
        },

        watch: {
            tableData: {
                handler: function (val) {
                }
            }
        },

        mounted(){
            if (!useDvFlagAccess('beepiz-patrols-can:read')) {
                this.$router.push({ name: 'AccessDenied', params: { slug: 'patrols'} })
            } else {
                if(!useDvFlagAccess('beepiz-patrols-can:delete')){
                    this.tableColumns.rowActions.actions.splice(1,1);
                }
    
                if(!useDvFlagAccess('beepiz-patrols-can:create')){
                    this.tableColumns.rowActions.actions.splice(0,1);
                }
    
                this.loadData(1);
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
